/**
 * @author - Branko Sekulic
 *
 * @Usage:       $.fn.selectOverlap()
 *
 *@Additional infos:
 *
 *         Plugin will add 3 class
 *
 *         j-select-holder - with this class you can select all select button accross the site (js class).
 *         j-select-[name] - this class will be assigned if button has name attribute (js class).
 *         select-holder - with this class you can style select button across the site (css class).
 *
 *         Note: Letter: "j-" is reserved letter for javascript, please DON'T use this class for CSS styles
 *
 * @example:
 *         $('select').selectOverlap();
 *
 *      Output:
 *
 *      <div class="j-select-holder select-holder j-select-example" style="position: relative;">
 *          <div style="cursor: pointer; opacity: 1;" class="select-text">Select Make</div>
 *          <select name="example" data-inited="yes" style="cursor: pointer; opacity: 0; position: absolute; top: 0px; left: 10px; width: 100%;">
 *              <option value="">Select Menu</option>
 *              <option value="option1">Option 1</option>
 *              ...
 *          </select>
 *          <span class="arrow-icon"></span>
 *      </div>
 *
 */

(function( $ ) {
    $.fn.selectOverlap = function() {

        var options = {
            'container' : {
                'position' : 'relative'
            },
            'select' : {
                'cursor' : 'pointer',
                'opacity' : '0',
                'position' : 'absolute',
                'top' : '0',
                'left' : '0',
                'width' : '100%'
            },
            'back' : {
                'cursor' : 'pointer'
            }
        };


        /**
         * Updating target with select box value
         * @param {Object} select
         * @param {Object} target
         */
        var change = function(select, target){
            var value = $(select).find(':selected').html();

            $(target).html(value);

            /** add placeholder class in case that data-placeholder text is defined **/
            if($(select).data('placeholder')) {
                if(value === $(select).data('placeholder')) {
                    $(target).addClass('select-placeholder');
                } else {
                    $(target).removeClass('select-placeholder');
                }
            }

            if($(select).find('option').length == 1){
                $(select).attr('disabled', 'disabled');
                $(target).css('opacity', '0.5');
            }else{
                $(select).removeAttr('disabled');
                $(target).css('opacity', '1');
            }
        };

        $(this).each(function(){
            var $this = $(this);

            if($(this).attr('data-inited') == 'yes'){
                change(this, $(this).prev()[0]);
                return;
            }

            $(this).attr('data-inited', 'yes');

            /** container and image holder */
            var container = document.createElement('div');
            var back = document.createElement('div');
            var arrowIcon = document.createElement('span');

            var multiple = document.createElement('ul');
            var selected = {};

            /** Applying styles */
            $(container).addClass('j-select-holder select-holder');
            for(var i in options.container){
                $(container).css(i, options.container[i]);
            }

            // Hover state
            $(container).hover(function(){
                $(this).addClass('hover');
            }, function(){
                $(this).removeClass('hover');
            });

            // Focus state
            $(this).focus(function(){
                $(container).removeClass('hover');
                $(container).addClass('focus');
            }).blur(function(){
                $(container).removeClass('focus');
            });

            if($(this).attr('name')){
                $(container).addClass('j-select-' + $(this).attr('name')  + ' ' + ($(this).attr('data-class') ? $(this).attr('data-class') : ''));
            }

            if($(this).css('display') == 'none'){
                $(container).css('display', 'none');
            }

            for(i in options.back){
                $(back).css(i, options.back[i]);
            }

            for(i in options.select){
                $(this).css(i, options.select[i]);
            }

            if($(this).attr('disabled') == 'disabled'){
                $(back).css('opacity', '0.5');
            }

            if ($(this).attr('multiple')) {
                $(this).hide();
                $(back).text($(this).data('defaultText'));
                $(multiple).addClass('select-multiple').addClass('hide');
                var selOptions = $(this).find('option');
                $.each(selOptions, function(idx, option) {
                    selected[$(option).prop('value')] = {selected: false, text: $(option).text()};
                    $('<li data-value="' + $(option).prop('value') + '"><i class="icon-yes unselected"></i>' + $(option).text() + '</li>')
                        .appendTo($(multiple))
                        .on('click', function(e) {
                            e.stopPropagation();
                            var selectedValue = $(this).data('value');
                            var selectedArr = [];
                            selected[selectedValue].selected = !selected[selectedValue].selected;
                            for (var item in selected) {
                                if (selected[item].selected) {
                                    selectedArr.push(item);
                                }
                            }
                            $this.val(selectedArr);
                            if (selectedArr.length) {
                                $(back).text('Multiple Filters Selected');
                            } else {
                                $(back).text($this.data('defaultText'));
                            }
                            $this.trigger('change');
                            $(this).children('i').toggleClass('unselected');
                        });
                });

                $('body').on('click', function(e) {
                    if (!$(multiple).hasClass('hide')) {
                        $(multiple).addClass('hide');
                    }
                });
            }

            /** Appending select box and image holder to container */
            $(container).insertBefore(this);
            $(back).addClass('select-text').appendTo(container);
            $(this).appendTo(container);
            $(arrowIcon).addClass('arrow-bottom').appendTo(container);

            if ($(this).attr('multiple')) {
                $(container).append(multiple);
                $([back, arrowIcon]).on('click', function(e) {
                    e.stopPropagation();
                    $(multiple).toggleClass('hide')
                });
            } else {
                /** Prepopulating selected values */
                change(this, back);
                /** Attaching onchange event */
                $(this).change(function(){
                    change(this, back);
                });
            }

        });
    };
})(jQuery);
